module.exports = __webpack_public_path__ + "static/media/imbibe.92823165.jpeg";